import script from "./MainttennaceSch.vue?vue&type=script&setup=true&lang=js"
export * from "./MainttennaceSch.vue?vue&type=script&setup=true&lang=js"

import "./MainttennaceSch.vue?vue&type=style&index=0&id=2c61d322&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c61d322"]])

export default __exports__